// The sample report's headline numbers (MKT-622), kept apart from the full
// fixture so the landing page and connect page ship only these. They are a
// contract with the paid landing page on skedsocial.com, which quotes them:
// change them and that page together. sample-report.test.ts pins them.

import type { CanonicalPlatform } from "../utm/types";

export const SAMPLE_REPORT_LABEL = "Sample report: a fictional 5-venue hospitality group";

export interface SamplePlatform {
  platform: CanonicalPlatform;
  sessions: number;
  engagedSessions: number;
  keyEvents: number;
  pageviews: number;
}

// Ranked by sessions, as the aggregator returns them.
export const SAMPLE_PLATFORMS: readonly SamplePlatform[] = [
  {
    platform: "Instagram",
    sessions: 9_840,
    engagedSessions: 6_210,
    keyEvents: 388,
    pageviews: 23_600,
  },
  {
    platform: "Facebook",
    sessions: 4_120,
    engagedSessions: 2_300,
    keyEvents: 131,
    pageviews: 9_480,
  },
  { platform: "TikTok", sessions: 3_160, engagedSessions: 1_520, keyEvents: 41, pageviews: 5_370 },
  { platform: "Pinterest", sessions: 690, engagedSessions: 540, keyEvents: 14, pageviews: 1_700 },
  { platform: "LinkedIn", sessions: 610, engagedSessions: 480, keyEvents: 38, pageviews: 1_720 },
];

const total = (pick: (p: SamplePlatform) => number) =>
  SAMPLE_PLATFORMS.reduce((acc, p) => acc + pick(p), 0);

export const SAMPLE_HEADLINE = {
  socialSessions: total((p) => p.sessions),
  engagedSessions: total((p) => p.engagedSessions),
  keyEvents: total((p) => p.keyEvents),
  utmHealthScore: 68,
} as const;

/** The three numbers every sample card shows, in order. */
export const SAMPLE_HEADLINE_METRICS = [
  { label: "Social sessions", value: SAMPLE_HEADLINE.socialSessions },
  { label: "Engaged", value: SAMPLE_HEADLINE.engagedSessions },
  { label: "Bookings", value: SAMPLE_HEADLINE.keyEvents },
] as const;

/** Top `n` platforms with bar widths scaled to the leader (0 to 100). */
export function samplePlatformBars(n: number) {
  const top = SAMPLE_PLATFORMS[0]?.sessions ?? 1;
  return SAMPLE_PLATFORMS.slice(0, n).map((p) => ({
    platform: p.platform,
    sessions: p.sessions,
    pct: Math.round((p.sessions / top) * 100),
  }));
}
